<template>
  <div style="z-index: 2000;">
    <div v-if="showSpinner">
      <mdb-spinner/> {{spinnerMessage}}
    </div>
    <div v-if="!showSpinner" class="text-right view-switcher">
      <mdb-btn v-if="mode=='folders'" floating icon="search" size="sm" tag="a" @click="switchView('search')"/>
      <mdb-btn v-if="mode=='search'" floating icon="folder-tree" size="sm" tag="a" @click="switchView('folders')"/>
    </div>
    <div v-if="!showSpinner && mode == 'search'" class="text-left">
      <mdb-input v-model="query" placeholder="Find an event image by tag, caption or event title." type="text"
                 @keydown.native="handleKeyDown"/>
      <mdb-btn :disabled="!query" icon="search" size="sm" @click="searchByTag">Search</mdb-btn>
      <div v-if="searchMessage" class="text-info">{{ searchMessage }}</div>
    </div>
    <div v-if="initialLoad && !showSpinner && mode=='folders'" class="text-left">
      <mdb-breadcrumb class="breadcrumb-with-arrows">
        <mdb-breadcrumb-item v-for="(bc,i) in breadcrumbs" :key="i">
          <span v-if="breadcrumbs.length == i+1">{{ bc.name }}</span>
          <a v-if="i+1 < breadcrumbs.length" href="" @click.prevent="loadFolders(bc)">{{ bc.name }}</a>
        </mdb-breadcrumb-item>
      </mdb-breadcrumb>
      <mdb-row>
        <mdb-col v-for="folder in folders" v-bind:key="folder.id" md="6">
          <a role="button" @click="loadFolders(folder)">
            <mdb-icon far icon="folder" size="2x"/>
            {{ folder.name }}
          </a>
        </mdb-col>
      </mdb-row>
    </div>
    <div v-if="!showSpinner">
      <mdb-row v-if="currentFolder">
        <mdb-col md="12">
          <h5 class="text-left">{{ currentFolder.name }}</h5>
          <div class="text-left">
            <mdb-btn v-if="readyToUpload" color="success" icon="upload" @click="uploadPhotos">Upload Now</mdb-btn>
            <mdb-file-upload :disabled="uploading" :files="files" multiple @change="handleChange"/>
            <div class="small text-center">Max Size is 8MB</div>
          </div>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <h5 v-if="images.length>0">Select an image:</h5>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col v-for="image in images" v-bind:key="image.id" md="3">
          <mdb-card class="mb-4">
            <mdb-view class="zoom">
              <a role="button" @click="selectImage(image)">
                <mdb-card-image :src="image.thumb"></mdb-card-image>
                <mdb-mask overlay="white-slight" waves/>
              </a>
            </mdb-view>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </div>
  </div>
</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import error from '../common/Error'
import mdbFileUpload from 'mdbvue-file-upload'
import {
  mdbBreadcrumb,
  mdbBreadcrumbItem,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbRow,
  mdbSpinner,
  mdbView
} from 'mdbvue';

export default {
  name: "ImageSelector",
  display: "Image Browser",
  order: 1,
  props: {
    group: {
      type: Object,
      default: null
    },
    emitOnSelection: {
      type: String,
      default: null
    }
  },
  components: {
    mdbBtn,
    mdbBreadcrumb,
    mdbBreadcrumbItem,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardImage,
    mdbMask,
    mdbIcon,
    mdbView,
    mdbSpinner,
    mdbCardBody,
    mdbFileUpload,
    mdbInput,
    error
  },
  mounted() {
    this.loadFolders(null)
  },
  data() {
    return {
      folders: [],
      images: [],
      breadcrumbs: [],
      error: null,
      currentFolder: null,
      showSpinner: false,
      spinnerMessage: "Please Wait...",
      uploading: false,
      files: [],
      readyToUpload: false,
      query: "",
      searchMessage: "",
      initialLoad: false,
      mode: "folders"
    };
  },
  methods: {
    loadFolders(folder) {
      this.spinnerMessage = "Loading folder."
      this.showSpinner = true
      this.folders = []
      this.images = []
      let url = "/imageFolder/list/"
      if (this.group) url += this.group.vanityPath
      if (folder) {
        url += "/?folder=" + folder.id
      }
      api.get(url).then(
          (results) => {
            this.folders = results.data.folders
            this.images = results.data.images
            this.breadcrumbs = results.data.breadcrumbs
            this.initialLoad = true
            this.currentFolder = this.breadcrumbs[this.breadcrumbs.length - 1]
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
        this.showSpinner = false
      })
    },

    handleChange(x) {
      if (this.files.length > 0) this.readyToUpload = true
      else this.readyToUpload = false
    },
    async uploadPhotos() {
      const reduce = require('image-blob-reduce')();
      this.uploading = true
      this.showUpload = false
      this.readyToUpload = false
      this.gotError = false
      this.spinnerMessage = "Uploading."
      this.showSpinner = true
      for (let image of this.files) {
        if (!this.gotError) {
          if (image.size >= 2000000) {

            await reduce.toBlob(image, {max: 2000})
                .then(blob => {
                  image.file = blob
                })
          }
          let g = null
          if (this.group) g = this.group.vanityPath
          let results = await api.generalUploadImage(this.currentFolder.id, g, image)
          if (results.success) {
            let img = results.image
            try {
              let urlCreator = window.URL || window.webkitURL
              img.thumb = urlCreator.createObjectURL(image)
            } catch (error) {
              console.error("Couldn't use uploaded blob as img.")
            }
            this.images.unshift(img)
          }
          else {
                this.gotError = true
                this.showUpload = true
                this.$notify.error({message: error.response.data, timeOut: 5000})
                this.uploading = false
          }
        }
      }
      this.showSpinner = false
      if (this.files.length ==1) this.selectImage(this.images[0])
      this.files = []
      this.readyToUpload = false
    },
    switchView: function (newMode) {
      this.folders = []
      this.images = []
      if (newMode == "folders") {
        this.loadFolders(null)
      }
      if (newMode == "search") {
        this.currentFolder = null
      }
      this.mode = newMode
    },
    selectImage: function (image) {
      this.$emit(this.emitOnSelection, image)
    },
    handleKeyDown(e) {
      if (e.keyCode == 13) this.searchByTag()
    },
    searchByTag: function () {
      this.lastDeleted = null
      this.spinnerMessage = "Searching"
      this.showSpinner = true
      let url = "/image/searchByTag/" + this.group.vanityPath + "/?q=" + this.query
      api.get(url).then(
          (details) => {
            if (details.data.length > 0) {
              this.images = details.data
              this.searchMessage = null
            } else this.searchMessage = "No images found."
          },
          (error) => {
            this.$notify.error({message: "Error loading folder"})
          }).then(() => {
        this.showSpinner = false
      })
    },
    navTop: function () {
      this.currentFolder = null
    }

  }
};
</script>
<style scoped>
.view-switcher {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
